/* unplugin-vue-components disabled */import script from "./EmptyListPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyListPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./EmptyListPlaceholder.vue?vue&type=style&index=0&id=4b8c73a1&lang=scss"

const __exports__ = script;

export default __exports__